<template>
  <div class="TableContent-cont" v-if="!is_null">
    <div class="equip-box">
      <ul class="passive_skill">
        <commonItem
          v-if="one.stunt"
          :content="one.stunt.tips"
          :score="7"
          :src="yhz_img2(one.stunt.icon, 2)"
        />

        <!-- {% if one.stunt %}
        <li title_name="{{one.stunt.tips}}">
          <img
            src="https://cbg-tx3.res.netease.com/images/skill/icon/{{one.stunt.icon}}.jpg"
            width="34"
            height="34"
          />
          <div class="score">7</div>
        </li>
        {% endif %} -->
      </ul>
    </div>
    <div class="equipment-info clear">
      <div class="equipment-info-box" v-for="(i, index) in 3" :key="index">
        <div class="pic-con">
          <img :src="`https://cbg-tx3.res.netease.com/images/${equ(i).icon}`" />
          <p>
            <span class="equip-name">
              {{ equ(i).name }}
            </span>
            <span class="equip-name-detail">
              {{ equ(i).lv }}
            </span>
          </p>
        </div>
        <div class="info-con">
          <div v-html="equ(i).tips"></div>
        </div>
      </div>
    </div>
  </div>
  <div v-else></div>
</template>

<script setup>
import { defineProps, ref, computed, inject } from 'vue';
const { yhz_img2 } = inject('filters');
const props = defineProps({
  one: {
    type: Object,
    default: () => ({}),
  },
});

// 计算属性
const equ = computed(() => {
  return (index) => props.one?.equs[index] || {};
});

const is_null = computed(() => {
  return Object.keys(props.one?.equs||{}).length == 0;
});
</script>
